import { FormElements } from '@custom-components';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import React from 'react';
import * as yup from 'yup';
import FileUpload from '../../BuildingBlocks/FileUpload/FileUpload';
import Modal from '../Modal/Modal';

function DocumentUploadModal(props) {
  const { submitDocument, closeModal } = props;
  const initialState = {
    formName: '',
    detail: '',
    version: '',
    document: {}
  };
  const validationSchema = () =>
    yup.object().shape({
      formName: yup.string().required('Please Name your document'),
      detail: yup.string().required('Please enter some details'),
      version: yup.string(),
      document: yup.object().required()
    });
  let submitCount = 0;

  return (
    <Formik initialValues={initialState} validationSchema={validationSchema()} onSubmit={submitDocument}>
      {({ handleSubmit, handleChange, errors, values }) => (
        <Modal
          openModal
          handleClose={closeModal}
          title="UPLOAD DOCUMENT"
          actions={[
            {
              label: 'CANCEL',
              onClick: closeModal,
              btnTheme: 'secondary'
            },
            {
              label: 'SUBMIT',
              onClick: () => {
                submitCount += 1;
                handleSubmit();
              },
              btnTheme: 'primary'
            }
          ]}
        >
          <form>
            <FileUpload
              name="document"
              label="New Document"
              value={values.document}
              onChange={handleChange}
              error={!!errors.document}
              errorText={errors.document}
              required
            />
            <FormElements.Select
              name="formName"
              label="Form Type"
              value={values.formName}
              onChange={handleChange}
              error={submitCount > 0 && !!errors.formName}
              errorText={errors.formName}
              options={[
                { label: 'Master Service Agreement', value: 'Master Service Agreement' },
                { label: 'Property Agreement', value: 'Property Agreement' }
              ]}
              required
            />
            <FormElements.TextInput
              name="detail"
              label="Detail"
              value={values.detail}
              onChange={handleChange}
              error={submitCount > 0 && !!errors.detail}
              errorText={errors.detail}
              required
            />
            <FormElements.TextInput
              name="version"
              label="Version"
              value={values.version}
              onChange={handleChange}
              error={submitCount > 0 && !!errors.version}
              errorText={errors.version}
              required
            />
          </form>
        </Modal>
      )}
    </Formik>
  );
}

DocumentUploadModal.propTypes = {
  submitDocument: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};

export default DocumentUploadModal;
